define('BookingEngine/app-BookNow/main',["util", '../app-BEBasket/module', '../app-General/dialog', '../../app/ui/dialog'], function (util, beBasket, generalDialog, dialog) {    
    return {
        ActivateBookNow: function () {
            function isNullUndefEmpty(variable) {
                return (variable === null || variable === undefined || variable === '');
            }     

            $('#bookNowContinue').on('click', function () {
                AdlAddUpdateItem("BookingJourneyStep", "priceitinerary");
            });

            var container = $("#booknow");

            var activateBookNow = $.ajax({
                url: window.location.protocol + '//' + window.location.host + '/booknowmodule/activate',
                type: "GET",
            });

            activateBookNow.done(function (data, status, xhr) {
                var ct = xhr.getResponseHeader("content-type") || "";

                if (ct.indexOf('json') > -1) {
                    window.location.replace(data.errorUrl);

                    return;
                }
                
                container.html(data).show();

                util.initialisePopovers();

                container.find(".btnItinerary").on("click", function (event) {
                    event.preventDefault();
                    generalDialog.showDialog("/basketitinerary/index");
                });

                container.find(".btnItinerary").show();

                $("#BrandPhoneNumber").on("click", function (event) {
                    if ($(window).width() >= 768) {
                        event.preventDefault();
                    }
                });

                // Booking Status
                var availabilityStatus = $('#availabilityStatus').text();

                if (availabilityStatus == "NoAvailability") {
                    availabilityStatus = "notavailable";

                    dialog.closeAll();   

                    //ADL call
                    AdlAddUpdateItem("pageName", "travel|purchase|priceanditinerary|notavailable");

                    function adlBookAndPayNA() {
                        util.satelliteTrack("virtualPageViewTBJ");

                        //after the tracking call set previous page name to this value
                        //set a timeout to prevent it getting set before it's been read
                        //also add it to local storage so that a page change picks up the correct value
                        setTimeout(function () {
                            var prevpage = localStorage.getItem("previousPageName");

                            if (!isNullUndefEmpty(prevpage)) {
                                AdlAddUpdateItem("previousPageName", prevpage);
                            }

                            localStorage.setItem("previousPageName", "travel|purchase|priceanditinerary|notavailable");
                        }, 999);
                    };

                    clearTimeout(VPVtimer);
                    VPVtimer = setTimeout(adlBookAndPayNA, 250);
                    if (typeof (_ictt) !== 'undefined') {
                        _ictt.push(['_allocate']);
                    }
                } else if (availabilityStatus == 'OnRequest') {
                    availabilityStatus = "onrequest";
                    //ADL call
                    AdlAddUpdateItem("pageName", "travel|purchase|priceanditinerary|onrequest");

                    function adlBookAndPayOR() {
                        util.satelliteTrack("virtualPageViewTBJ");

                        //after the tracking call set previous page name to this value
                        //set a timeout to prevent it getting set before it's been read
                        //also add it to local storage so that a page change picks up the correct value
                        setTimeout(function () {
                            var prevpage = localStorage.getItem("previousPageName");

                            if (!isNullUndefEmpty(prevpage)) {
                                AdlAddUpdateItem("previousPageName", prevpage);
                            }

                            localStorage.setItem("previousPageName", "travel|purchase|priceanditinerary|onrequest");
                        }, 999);
                    };

                    clearTimeout(VPVtimer);
                    VPVtimer = setTimeout(adlBookAndPayOR, 250);
                    if (typeof (_ictt) !== 'undefined') {
                        _ictt.push(['_allocate']);
                    }
                } else if (availabilityStatus == 'Available') {
                    availabilityStatus = "bookandpay";

                    //ADL call
                    AdlAddUpdateItem("pageName", "travel|purchase|priceanditinerary|bookandpay");

                    function adlBookAndPay() {
                        util.satelliteTrack("virtualPageViewTBJ");

                        //after the tracking call set previous page name to this value
                        //set a timeout to prevent it getting set before it's been read
                        //also add it to local storage so that a page change picks up the correct value
                        setTimeout(function () {
                            var prevpage = localStorage.getItem("previousPageName");

                            if (!isNullUndefEmpty(prevpage)) {
                                AdlAddUpdateItem("previousPageName", prevpage);
                            }

                            localStorage.setItem("previousPageName", "travel|purchase|priceanditinerary|bookandpay");
                        }, 999);
                    };

                    clearTimeout(VPVtimer);
                    VPVtimer = setTimeout(adlBookAndPay, 250);
                } else {
                    availabilityStatus = "";
                }

                localStorage.setItem("pandiState", availabilityStatus);
                AdlAddUpdateItem("pandiState", availabilityStatus);

                var quoteref = "";

                if ($('#sagaQuoteRefDiv').is(':visible') && $('#sagaQuoteRefDiv').attr("quoteref") !== undefined) {
                    quoteref = $('#sagaQuoteRefDiv').attr("quoteref").trim();
                }

                AdlAddUpdateItem("quoteReference", quoteref);
                localStorage.setItem("quoteReference", quoteref);

                var totalPrice = $('#totalPrice').text();

                if (totalPrice > "0.00") {
                    AdlAddUpdateItem("totalPrice", totalPrice);
                    localStorage.setItem("totalPrice", totalPrice);
                }

            });

            activateBookNow.fail(function (error) {
                container.html(error).show();
            });

            activateBookNow.always(function () {
                dialog.closeAll();   
                beBasket.updateBasket();
                if ($(".pickyourcabinSummary").is(':visible')) {
                    $("html, body").animate({ scrollTop: $(".pickyourcabinSummary").offset().top - 15 }, "slow", "swing");
                }
            });
        },

        UpdateSummary: function (variableStatus) {
            $("#booknowactive").attr("data-summary", variableStatus);
        }
    }
});
